"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faWindowClose_1 = require("@fortawesome/free-solid-svg-icons/faWindowClose");
const faCheck_1 = require("@fortawesome/free-solid-svg-icons/faCheck");
const faPencilAlt_1 = require("@fortawesome/free-solid-svg-icons/faPencilAlt");
const faUndoAlt_1 = require("@fortawesome/free-solid-svg-icons/faUndoAlt");
const faBan_1 = require("@fortawesome/free-solid-svg-icons/faBan");
const faQuestionCircle_1 = require("@fortawesome/free-solid-svg-icons/faQuestionCircle");
const faHandPaper_1 = require("@fortawesome/free-solid-svg-icons/faHandPaper");
const faClipboardList_1 = require("@fortawesome/free-solid-svg-icons/faClipboardList");
const faChevronCircleRight_1 = require("@fortawesome/free-solid-svg-icons/faChevronCircleRight");
const faChevronCircleLeft_1 = require("@fortawesome/free-solid-svg-icons/faChevronCircleLeft");
const faBolt_1 = require("@fortawesome/free-solid-svg-icons/faBolt");
const faListCheck_1 = require("@fortawesome/free-solid-svg-icons/faListCheck");
const ConfirmModal_1 = __importDefault(require("chaire-lib-frontend/lib/components/modal/ConfirmModal"));
const InterviewReviewLinks_1 = __importDefault(require("./InterviewReviewLinks"));
const ValidationLinks = ({ handleInterviewSummaryChange, updateValuesByPath, interviewIsQuestionable, interviewUuid, nextInterviewUuid, prevInterviewUuid, refreshInterview, refreshInterviewWithExtended, resetInterview, interviewIsComplete, interview }) => {
    const { t } = (0, react_i18next_1.useTranslation)('admin');
    // State for confirmation modals
    const [showResetConfirmation, setShowResetConfirmation] = (0, react_1.useState)(false);
    const [showEditFrozenConfirmation, setShowEditFrozenConfirmation] = (0, react_1.useState)(false);
    // Check if interview is frozen
    const interviewIsFrozen = interview.is_frozen === true;
    const handleResetClick = (e) => {
        e.preventDefault();
        setShowResetConfirmation(true);
    };
    // FIXME Add an option to not show this dialog again for the session when https://github.com/chairemobilite/transition/pull/1510 is merged
    const handleEditClick = (e) => {
        e.preventDefault();
        if (interviewIsFrozen) {
            setShowEditFrozenConfirmation(true);
        }
        else {
            window.open(`/admin/survey/interview/${interviewUuid}`, '_blank');
        }
    };
    const handleResetConfirm = () => {
        resetInterview();
        setShowResetConfirmation(false);
    };
    const handleEditFrozenConfirm = () => {
        window.open(`/admin/survey/interview/${interviewUuid}`, '_blank');
        setShowEditFrozenConfirmation(false);
    };
    return (react_1.default.createElement("p", { className: "center _large" },
        react_1.default.createElement("a", { href: "#", onClick: (e) => {
                e.preventDefault();
                handleInterviewSummaryChange(null);
            }, title: t('admin:closeInterviewSummary') },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faWindowClose_1.faWindowClose })),
        react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            "\u00A0\u00A0",
            react_1.default.createElement("a", { href: "#", className: `_together ${interviewIsQuestionable ? '_red _active-background' : '_green'}`, title: t(interviewIsQuestionable ? 'admin:UnsetQuestionable' : 'admin:SetQuestionable'), onClick: (e) => {
                    e.preventDefault();
                    updateValuesByPath({ is_questionable: !interviewIsQuestionable });
                } },
                react_1.default.createElement("span", { className: "_small" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faQuestionCircle_1.faQuestionCircle }),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faHandPaper_1.faHandPaper })))),
        react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            "\u00A0\u00A0",
            react_1.default.createElement("a", { href: "#", className: `_together _red${interviewIsComplete === false ? ' _active-background' : ''}`, title: interviewIsComplete === false ? t('admin:ClearCompletionStatus') : t('admin:SetIncomplete'), onClick: (e) => {
                    e.preventDefault();
                    // Second click on the same choice clears completion (null in DB).
                    updateValuesByPath({
                        is_completed: interviewIsComplete === false ? null : false
                    });
                } },
                react_1.default.createElement("span", { className: "_small" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faBan_1.faBan })),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faClipboardList_1.faClipboardList }))),
        react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            "\u00A0\u00A0",
            react_1.default.createElement("a", { href: "#", className: `_together _green${interviewIsComplete === true ? ' _active-background' : ''}`, title: interviewIsComplete === true ? t('admin:ClearCompletionStatus') : t('admin:SetComplete'), onClick: (e) => {
                    e.preventDefault();
                    // Second click on the same choice clears completion (null in DB).
                    updateValuesByPath({
                        is_completed: interviewIsComplete === true ? null : true
                    });
                } },
                react_1.default.createElement("span", { className: "_small" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faCheck_1.faCheck })),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faClipboardList_1.faClipboardList }))),
        ' ',
        "\u00A0\u00A0",
        react_1.default.createElement(InterviewReviewLinks_1.default, { interviewUuid: interviewUuid }),
        " \u00A0\u00A0",
        react_1.default.createElement("a", { href: "#", onClick: handleEditClick, title: t('admin:editValidationInterview') },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faPencilAlt_1.faPencilAlt })),
        ' ',
        react_1.default.createElement("a", { href: "#", onClick: (e) => {
                e.preventDefault();
                refreshInterview();
            }, title: t('admin:refreshInterviewAndAudit') },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faListCheck_1.faListCheck })),
        ' ',
        react_1.default.createElement("a", { href: "#", className: "_together", onClick: (e) => {
                e.preventDefault();
                refreshInterviewWithExtended();
            }, title: t('admin:refreshInterviewAndAuditWithExtended') },
            react_1.default.createElement("span", { className: "_small" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faBolt_1.faBolt })),
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faListCheck_1.faListCheck })),
        ' ',
        react_1.default.createElement("a", { href: "#", onClick: handleResetClick, title: t('admin:resetInterview') },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faUndoAlt_1.faUndoAlt })),
        prevInterviewUuid && (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            react_1.default.createElement("a", { href: "#", onClick: (e) => {
                    e.preventDefault();
                    handleInterviewSummaryChange(prevInterviewUuid);
                }, title: t('admin:prevInterview') },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronCircleLeft_1.faChevronCircleLeft })))),
        nextInterviewUuid && (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            react_1.default.createElement("a", { href: "#", onClick: (e) => {
                    e.preventDefault();
                    handleInterviewSummaryChange(nextInterviewUuid);
                }, title: t('admin:nextInterview') },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronCircleRight_1.faChevronCircleRight })))),
        react_1.default.createElement(ConfirmModal_1.default, { isOpen: showResetConfirmation, closeModal: () => setShowResetConfirmation(false), title: t('admin:resetInterviewConfirmTitle'), text: t('admin:resetInterviewConfirmMessage'), confirmAction: handleResetConfirm, confirmButtonLabel: t('admin:confirmButton'), cancelButtonLabel: t('admin:cancelButton') }),
        react_1.default.createElement(ConfirmModal_1.default, { isOpen: showEditFrozenConfirmation, closeModal: () => setShowEditFrozenConfirmation(false), title: t('admin:editReviewedInterviewConfirmTitle'), text: t('admin:editReviewedInterviewConfirmMessage'), confirmAction: handleEditFrozenConfirm, confirmButtonLabel: t('admin:confirmButton'), cancelButtonLabel: t('admin:cancelButton') })));
};
exports.default = ValidationLinks;
//# sourceMappingURL=ValidationLinks.js.map